import { GoalType } from '@griply/types';
import { useCompleteGoal } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { Goal } from 'shared/types/goal';

export type CompleteListProps = {
  goal: Goal;
  onClose: () => void;
};

export const CompleteList: React.FC<CompleteListProps> = ({
  goal,
  onClose,
}) => {
  const { t } = useTranslation();

  const completeGoal = useCompleteGoal();
  const isProject = goal.type === GoalType.Project;

  const onCompleteGoal = (e: React.MouseEvent) => {
    e.preventDefault();
    completeGoal(goal);
    onClose();
  };

  return !goal.frozenAt && !goal.archivedAt ? (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton onClick={onCompleteGoal} start={<Icon icon={Check} />}>
          {t(
            goal?.completedAt
              ? isProject
                ? 'context-menus.goal.labels.un-complete-project'
                : 'context-menus.goal.labels.un-complete'
              : isProject
                ? 'context-menus.goal.labels.complete-project'
                : 'context-menus.goal.labels.complete',
          )}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  ) : null;
};
